export const locale = {
    lang: 'es',
    data: {
        CUADRILLAS: {
            LIST: {
                TITLE: 'CUADRILLAS'
            }
        }
    }
};
